export type WebsocketMessage<TMessage = unknown> = TMessage

export enum WebsocketAuthenticationStatus {
  AUTHENTICATED = 'authenticated',
  ALREADY_AUTHENTICATED = 'already_authenticated',
}

export const WebsocketAuthenticatedStatus = [
  WebsocketAuthenticationStatus.AUTHENTICATED,
  WebsocketAuthenticationStatus.ALREADY_AUTHENTICATED,
]

export type WebsocketAuthenticationSuccessResponse = { status: WebsocketAuthenticationStatus }
export type WebsocketAuthenticationErrorResponse = { error: string }
export type WebsocketAuthenticationResponse =
  | WebsocketAuthenticationSuccessResponse
  | WebsocketAuthenticationErrorResponse

export type AuthenticationRequestParams = { token: string }

export type WebsocketErrorResponse = { status: 'error'; message: string }
